<template>
  <div class="card" style="z-index:0;">
    <div class="row">
      <div class="col-10">
      <ul id="progressbar" class="text-center">
          <li class="active step0" id="step1" data-id="1">Carrinho</li>
          <li class="step0" id="step2" data-id="2" @click="voltarPara(2)">Confirmação de Dados <i v-if="flags.dadosEscritorio" class="text-danger fas fa-exclamation-triangle"></i></li>
          <li class="step0" id="step3" data-id="3" @click="voltarPara(3)">Pagamento <i v-if="flags.pagamento" class="text-danger fas fa-exclamation-triangle"></i></li>
      </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'progresso',
  props: {
    status: {
      type: Number,
      default: 1
    }
  },

  computed: {
    progressoAtual: {
      get () {
        return this.status
      },
      set (novoValor) {
        this.$emit('atualizarStatus', novoValor)
      }
    }
  },

  data: () => {
    return {
      progressoConcluido: 0,
      listaDeErros: {},
      flags: {
        pagamento: false,
        dadosEscritorio: false
      }
    }
  },

  mounted () {
    this.progressoConcluido = this.status
  },

  methods: {
    voltarPara (progresso) {
      if (progresso <= this.progressoConcluido) {
        this.progressoAtual = progresso
      }
    },
    proximo () {
      this.progressoAtual = this.progressoAtual + 1
    },
    aplicarClasseCompleta () {
      const statusAtual = this.progressoAtual - 1
      const ul = document.getElementById('progressbar')
      const previousLis = Array.from(ul.querySelectorAll('li')).filter(li => li.getAttribute('data-id') <= statusAtual)
      previousLis.forEach(li => {
        li.classList.add('completed')
      })
    },
    aplicarClasseAtiva () {
      const statusAtual = this.progressoAtual
      const ul = document.getElementById('progressbar')
      const previousLis = Array.from(ul.querySelectorAll('li')).filter(li => li.getAttribute('data-id') <= statusAtual)
      previousLis.forEach(li => {
        li.classList.add('active')
      })
    }
  },
  watch: {
    progressoAtual (novoValor, valorAntigo) {
      if (novoValor > this.progressoConcluido) {
        this.progressoConcluido = novoValor
      }
      this.aplicarClasseAtiva()
      this.aplicarClasseCompleta()
    }
  }
}
</script>
<style scoped>
#progressbar {
    overflow: hidden;
    margin-top: 20px;
}

#progressbar li {
    list-style-type: none;
    font-size: 0.9rem;
    flex-wrap: wrap;
    width: 33%;
    float: left;
    position: relative;
    font-weight: 400;
}

#progressbar #step1:before {
  content: "1";
  color: #C5CAE9;
}

#progressbar #step2:before {
  content: "2";
  color: #C5CAE9;
}

#progressbar #step3:before {
  content: "3";
  color: #C5CAE9;
}

#progressbar li:before {
    width: 2rem;
    height: 2rem;
    line-height: 1.6rem;
    display: block;
    font-size: 1.2rem;
    background: white;
    border: 1px solid #C5CAE9;
    border-radius: 50%;
    margin: auto;
    padding: 0px;
    z-index: -1;
}

/*ProgressBar connectors*/
#progressbar li:after {
    content: '';
    width: 100%;
    height: 5px;
    background: #F0F0F0;
    position: absolute;
    left: 0;
    top: 14px;
    z-index: -1;
}

#progressbar li:last-child:after {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    position: absolute;
    left: -50%;
}

#progressbar li:nth-child(2):after, #progressbar li:nth-child(3):after {
    left: -50%;
}

#progressbar li:first-child:after {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    position: absolute;
    left: 50%;
}

#progressbar li:last-child:after {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}

#progressbar li:first-child:after {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
}

#progressbar li.active:before {
    background: #194175;
    border: 1px solid #194175;
}
#progressbar li.active:before, #progressbar li.active:after {
    background: #194175;
}
#progressbar li.completed:before {
  content: "\2713" !important;
  background: #fff;
  color: #194175 !important;
  border: 1px solid #194175;

}
</style>
